import * as joint from '@joint/core';
import { Jurisdiction, IFillColorable, ITextColorable } from './types';
import { DefaultShapeColors } from './constants';

export class Node extends joint.dia.Element implements IFillColorable, ITextColorable {
    //_entityIds: string[] = [];
    get entityIds() {
        return this.prop('entityIds');
    }
    set entityIds(value: string[]) {
        this.prop('entityIds', value);
    }

    get isNewEntity() {
        return this.prop('isNewEntity');
    }
    set isNewEntity(value: boolean) {
        this.prop('isNewEntity', value);
    }

    public setColor(color: string) {
        this.attr('body/fill', color);
    }

    public getColor(): string {
        return (this.attr('body/fill') as string) || '#FFFFFF';
    }
    
    public setStrokeColor(color: string) {
        this.attr('body/stroke', color);
    }

    public setFontColor(color: string) {
        // Primary label text color
        this.attr('label/fill', color);
        // Secondary label (if present)
        this.attr('label2/fill', color);
    }

    public getFontColor(): string {
        return (this.attr('label/fill') as string) || '#000000';
    }

    public setColorByJurisdiction(jurisdiction: Jurisdiction) {
        switch (jurisdiction) {
            case Jurisdiction.US:
                this.setColor(DefaultShapeColors.PrimaryColor);
                break;
            case Jurisdiction.NonUS:
                this.setColor(DefaultShapeColors.SecondaryColor);
                break;
            case Jurisdiction.Mixed: // overridden in EntityGroup
                this.setColor(DefaultShapeColors.PrimaryColor);
                break;
            case Jurisdiction.ThirdParty:
                this.setColor(DefaultShapeColors.ThirdPartyColor);
                break;
            default:
                this.setColor(DefaultShapeColors.PrimaryColor);
                break;
        }
    }

    public setLabel(label: string) {
        // if the string is too long, split on all spaces and add a newline where the string exceeds a certain length
        if (label.length > 15) {
            var splitLabel = '';
            var words = label.split(' ');
            var lineLength = 0;
            words.forEach(word => {
                if (lineLength + word.length > 15) {
                    splitLabel += '\n' + word + ' ';
                    lineLength = word.length;
                } else {
                    splitLabel += word + ' ';
                    lineLength += word.length;
                }
            });

            this.attr('label/text', splitLabel.trim());
        } else {
            this.attr('label/text', label);
        }
    }

    public setSecondaryLabel(label: string) {
        // if the string is too long, split on all spaces and add a newline where the string exceeds a certain length
        if (label.length > 15) {
            var splitLabel = '';
            var words = label.split(' ');
            var lineLength = 0;
            words.forEach(word => {
                if (lineLength + word.length > 15) {
                    splitLabel += '\n' + word + ' ';
                    lineLength = word.length;
                } else {
                    splitLabel += word + ' ';
                    lineLength += word.length;
                }
            });
            this.attr('label2/text', splitLabel.trim());
        } else {
            this.attr('label2/text', label);
        }
    }
}
